import React from 'react';
import PropTypes from 'prop-types';

import ActionButton from './ActionButton';

function HeaderButton({ to, children, ...rest }) {
  return (
    <ActionButton
      onClick={() => {
        window.location.href = to;
      }}
      {...rest}
    >
      {children}
    </ActionButton>
  );
}

HeaderButton.propTypes = {
  ...ActionButton.propTypes,
  to: PropTypes.string,
};

export default HeaderButton;
